import React, { FC } from 'react';
import InputPickerWrapper from './InputPickerWrapper';
import TimePicker from './TimePicker';
import DatePicker from './DatePicker';
import DateTimePicker from './DateTimePicker';

type Props = {
    value: string | null;
    onChange: ((data: string) => void) | undefined;
    show: boolean;
    setShowTimePicker: (x: boolean) => void;
    format?: string;
    type: 'date' | 'time' | 'dateTime';
    buttonRef: React.RefObject<HTMLDivElement>;
    mainContainerClassName?: string;
};

const InputPickers: FC<Props> = ({
    value,
    onChange,
    show,
    setShowTimePicker,
    format,
    type,
    buttonRef,
    mainContainerClassName,
}) => {
    return (
        <>
            <InputPickerWrapper
                show={show}
                setShow={setShowTimePicker}
                buttonRef={buttonRef}
                className={mainContainerClassName}
            >
                {type === 'time' && <TimePicker value={value} onChange={onChange} format={format} show={show} />}
                {type === 'date' && <DatePicker value={value} onChange={onChange} format={format} show={show} />}
                {type === 'dateTime' && (
                    <DateTimePicker value={value} onChange={onChange} format={format} show={show} />
                )}
            </InputPickerWrapper>
        </>
    );
};

export default InputPickers;
